import React, { useEffect, useState } from 'react'
import AffiliateLayout from './AffiliateLayout'
import AddUserModal from './AddUserModal'
import { connectAffiliate } from './Affiliate.connect'
import { toastr } from 'react-redux-toastr'
import moment from 'moment'
import { useHistory } from 'react-router-dom'

const AffiliateUserlist = ({ actions }) => {
  const [open, setOpen] = useState(false)
  const [userList, setUserList] = useState(null)

  const history = useHistory()

  const getAffUsersList = async () => {
    await actions
      .getAffUsersList({
        limit: 100,
        page: 1,
      })
      .then((res) => {
        if (res?.data?.status) {
          setUserList(res?.data)
        }
      })
      .catch((e) => toastr.error('', `${e}`))
  }

  useEffect(() => {
    getAffUsersList()
  }, [])
  return (
    <AffiliateLayout>
      <div className="nw-affi-user-list-wrapper">
        <div className="table-responsive nw-affi-user-table">
          <table className="table">
            <thead>
              <tr>
                <th>User Name</th>
                <th>Balance</th>
                <th>Created Date Time</th>
                <th>Statement</th>
                <th>Profit / Loss</th>
              </tr>
            </thead>
            <tbody style={{ background: '#fff' }}>
              {userList?.data?.length > 0 ? (
                userList?.data?.map((item) => (
                  <tr key={item?.userName} className="user_list_tr">
                    <td className="text-center">{item?.user_name}</td>
                    <td className="text-center">{item?.balance}</td>
                    <td className="text-center">
                      {moment(item?.createdAt).format('DD/MM/YYYY hh:mm A')}
                    </td>
                    <td className="text-center">
                      <button
                        onClick={() =>
                          history.push(`/account_statement/${item?._id}`)
                        }
                        className="thm-but btn-gradient user_list_btn"
                      >
                        View
                      </button>
                    </td>
                    <td className="text-center">
                      <button
                        onClick={() =>
                          history.push(`/affiliate/profit-loss/${item?._id}`)
                        }
                        className="thm-but btn-gradient user_list_btn"
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="tabetdat">
                  <td colSpan={5}>
                    <div className="text-center affiliate-no-recoard-data">
                      No Records Found
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="nw-affi-add-new-user-btn-sec">
          <button
            className="nw-affi-add-new-user-btn"
            onClick={() => setOpen(!open)}
          >
            <span>
              <img src="/bonus/affi-add-user.svg" alt="affi-add-user" /> ADD NEW
              USER
            </span>
          </button>
        </div>
      </div>
      {open && <AddUserModal setOpen={setOpen} />}
    </AffiliateLayout>
  )
}

export default connectAffiliate()(AffiliateUserlist)
